<template>
  <UIInputNumber v-model="innerModel" :size :readonly @ready="handleReady" @paste="handlePaste" />
</template>

<script setup lang="ts">
import { computed, inject, ref } from 'vue'

import { InputSize } from '@types'

import { UIInputNumber } from '@ui/fields'

type Props = {
  readonly?: boolean
}

defineProps<Props>()

const modelValue = defineModel<any>()

const size = inject<InputSize>('size')

defineExpose({
  start() {
    inputRef.value?.select()
  },
})

const inputRef = ref<HTMLInputElement>()

const innerModel = computed({
  get() {
    return modelValue.value ? Number(modelValue.value) : null
  },
  set(value) {
    if (value === null || value === undefined) {
      modelValue.value = null
    } else {
      modelValue.value = value.toString()
    }
  },
})

const handleReady = (el: HTMLInputElement) => {
  inputRef.value = el
}

const handlePaste = (event: ClipboardEvent) => {
  const clipboardData = event.clipboardData
  if (!clipboardData) return

  const pastedData = clipboardData.getData('text/plain')
  if (!pastedData) return

  if (pastedData.includes('%')) {
    event.preventDefault()

    const numberValue = parseFloat(pastedData.replace('%', '')) / 100
    modelValue.value = numberValue
  }
}
</script>
